import React from 'react';
import {Col} from 'react-bootstrap';
import styles from './AuthBody.module.scss';
import {Outlet} from 'react-router';
import {PageFooter} from '../PageFooter/PageFooter';
import {getFullLogoLink, getLoginImageLink} from '../../../appTheme';
import {Paper} from "@mantine/core";

export function AuthBody(props: {}) {

  return (
    <div className={styles['auth-container']}>
      <Paper className={styles['auth-content']} shadow='md' radius={'md'}>
        <Col className={'fill-col'} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <img src={getFullLogoLink()} className={styles['logo']}/>
          <Outlet/>
        </Col>
      </Paper>
      <div className={styles['image-container']}>
        <img alt={'login-image'} src={getLoginImageLink()} className={styles['background-image']}/>
      </div>
      <div className={styles['footer']}>
        <PageFooter green={true}/>
      </div>
    </div>
  );
}
